import { render, staticRenderFns } from "./hqStuHealthKnowledgeEdit.vue?vue&type=template&id=c291faf0&scoped=true"
import script from "./hqStuHealthKnowledgeEdit.vue?vue&type=script&lang=js"
export * from "./hqStuHealthKnowledgeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c291faf0",
  null
  
)

export default component.exports